import Status from 'clarks/components/ivu-table/status'

let exports = {
   sort_creteria: { forms: [
         { type: 'select', class: 'col-12', model: 'criteria', validation: 'required', options: [
            { val: "1", label: 'Ascending'},
            { val: "-1", label: 'Descending'},
         ], label: 'Sort Criteria', filterable: true, clearable: true},
      ] 
   },
   form_fields_date: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_number: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_select: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_latitude: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_longitude: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_region: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_all: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   form_fields_date_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   form_fields_number_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   form_fields_select_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   form_fields_all_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   other_form_fields_date: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_number: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_select: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_longitude: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_latitude: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_region: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_all: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true},
      ] 
   },
   other_form_fields_date_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true,},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   other_form_fields_number_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true,},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   other_form_fields_select_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true,},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
   other_form_fields_all_multiple: { forms: [
         { type: 'select', class: 'col-12', model: 'other_table', validation: 'required', options: [], label: 'Table', filterable: true, clearable: true,},
         { type: 'select', class: 'col-12', model: 'field', validation: 'required', options: [], label: 'Field', filterable: true, clearable: true, multiple: true, max_tag_count: 2},
      ]
   },
}

let forms = {
   addVisuals: {
      icon: 'fa fa-university',
      title: 'Add Visuals',
      subtitle: 'Provide Visuals Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name',
            validation: 'required|min:3|max:500', label: 'Visualization Name',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'type',
            options: [
               { val: 'stat_card', label: 'Stat Card'},
               { val: 'doughnut', label: 'Doughnut Chart'},
               { val: 'pie', label: 'Pie Chart'},
               { val: 'line', label: 'Line Chart'},
               { val: 'bar', label: 'Bar Chart'},
               { val: 'area', label: 'Area Chart'},
               { val: 'calendar_week', label: 'Calendar Week'},
               { val: 'calendar', label: 'Calendar Chart'},
               { val: 'map', label: 'Map'},
               { val: 'region_map', label: 'Region Map'},
            ], validation: 'required', label: 'Visual Type'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'index',
            validation: 'required|min:1|max:500|numeric', label: 'Sort Number',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'class',
            options: [
               { val: 'col-12', label: 'Full Width'},
               { val: 'col-12 col-md-6', label: 'Half Width'},
               { val: 'col-12 col-md-4', label: 'A Third Width'},
               { val: 'col-12 col-md-3', label: 'Quarter Width'},
               { val: 'col-12 col-md-6 col-lg-2', label: 'A Sixth Width'},
            ], validation: 'required', label: 'Visual Size'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'table',
            options: [], validation: 'required', label: 'Table'
         },
         {
            type: 'form-select', class: 'col-12', model: 'date_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_date.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_date.forms },
            ], validation: '', label: 'Date Field'
         },
         {
            type: 'select', class: 'col-12', model: 'dashboard_link',
            options: [], validation: '', label: 'Dashboard Link'
         },
         {
            type: 'textarea', class: 'col-12', model: 'description', rows: '3',
            validation: 'required|min:3|max:500', label: 'Description'
         },
      ]
   },
   editVisuals: {
      icon: 'fa fa-university',
      title: 'Edit Visuals',
      subtitle: 'Update Visuals Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name',
            validation: 'required|min:3|max:500', label: 'Visualization Name',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'type',
            options: [
               { val: 'stat_card', label: 'Stat Card'},
               { val: 'doughnut', label: 'Doughnut Chart'},
               { val: 'pie', label: 'Pie Chart'},
               { val: 'line', label: 'Line Chart'},
               { val: 'bar', label: 'Bar Chart'},
               { val: 'area', label: 'Area Chart'},
               { val: 'calendar_week', label: 'Calendar Week'},
               { val: 'calendar', label: 'Calendar Chart'},
               { val: 'map', label: 'Map'},
               { val: 'region_map', label: 'Region Map'},
            ], validation: 'required', label: 'Visual Type'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'index',
            validation: 'required|min:1|max:500|numeric', label: 'Sort Number',
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'class',
            options: [
               { val: 'col-12', label: 'Full Width'},
               { val: 'col-12 col-md-6', label: 'Half Width'},
               { val: 'col-12 col-md-4', label: 'A Third Width'},
               { val: 'col-12 col-md-3', label: 'Quarter Width'},
               { val: 'col-12 col-md-6 col-lg-2', label: 'A Sixth Width'},
            ], validation: 'required', label: 'Visual Size'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'table',
            options: [], validation: 'required', label: 'Table'
         },
         {
            type: 'form-select', class: 'col-12', model: 'date_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_date.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_date.forms },
            ], validation: '', label: 'Date Field'
         },
         {
            type: 'select', class: 'col-12', model: 'dashboard_link',
            options: [], validation: '', label: 'Dashboard Link'
         },
         {
            type: 'textarea', class: 'col-12', model: 'description', rows: '3',
            validation: 'required|min:3|max:500', label: 'Description'
         },
      ]
   },
   stat_card: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'sub_type',
            options: [
               { val: 'total', label: 'Total'},
               { val: 'count', label: 'Count'},
               { val: 'average', label: 'Average'},
               { val: 'median', label: 'Median'},
               { val: 'min', label: 'Minimum'},
               { val: 'max', label: 'Maximum'},
            ], validation: '', label: 'Stat Card Type'
         },
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_date.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_date.forms },
            ], validation: 'required', label: 'Grouping Field'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_number.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_number.forms },
            ], validation: '', label: 'Number Field'
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'icon',
            validation: 'required|min:3|max:300', label: 'Icon',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'last_days',
            validation: 'required|min:1|max:10|numeric', label: 'Days Comparison',
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'days_difference',
            validation: 'min:1|max:10|numeric', label: 'Days Difference',
         },
      ]
   },
   line_visual: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_all.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_all.forms },
            ], validation: 'required', label: 'X-Axis'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_all_multiple.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_all_multiple.forms },
            ], validation: 'required', label: 'Y-Axis', multiple: true
         },
         {
            type: 'form-select', class: 'col-12', model: 'aggregation_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_select_multiple.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_select_multiple.forms },
            ], validation: '', label: 'Aggregation Field'
         },
         {
            type: 'form-select', class: 'col-12 col-md-6', model: 'sort_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: [...exports.form_fields_all.forms,...exports.sort_creteria.forms] },
               { val: "other_table", label: "Other Table", forms: [...exports.other_form_fields_all.forms,,...exports.sort_creteria.forms] },
            ], validation: '', label: 'Sort Field'
         },
         {
            type: 'select', class: 'col-12 col-md-6', model: 'orientation',
            options: [
               { val: 'vertical', label: 'Vertical'},
               { val: 'horizontal', label: 'Horizontal'},
            ], validation: '', label: 'Orientation'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'limit',
            validation: 'min:1|max:10|numeric', label: 'Record Limit',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'date_group_format',
            validation: 'min:4|max:50', label: 'Date Group Format', placeholder: 'e.g %d-%m'
         },
         {
            type: 'checkbox', class: 'col-12 custom-check', model: 'stacked', validation: '',
            label: 'Is Chart Stacked'
         },
      ]
   },
   pie_visual: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_select.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_select.forms },
            ], validation: 'required', label: 'Grouping Field'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_number.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_number.forms },
            ], validation: 'required', label: 'Number Field'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'limit',
            validation: 'min:1|max:10|numeric', label: 'Group Limit',
         },
      ]
   },
   calendar_visual: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_date.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_date.forms },
            ], validation: 'required', label: 'Date Field'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_number.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_number.forms },
            ], validation: 'required', label: 'Number Field'
         },
      ]
   },
   map_visual: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_latitude.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_latitude.forms },
            ], validation: 'required', label: 'Latitude'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_longitude.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_longitude.forms },
            ], validation: 'required', label: 'Longitude'
         },
         {
            type: 'text', form_type: 'number', class: 'col-12 col-md-6', model: 'limit',
            validation: 'min:1|max:10|numeric', label: 'Record Limit',
         },
      ]
   },
   map_region_visual: {
      icon: 'fa fa-text-height',
      title: 'Text',
      subtitle: 'Text Form Field',
      forms: [
         {
            type: 'form-select', class: 'col-12', model: 'x_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_region.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_region.forms },
            ], validation: 'required', label: 'Region'
         },
         {
            type: 'form-select', class: 'col-12', model: 'y_field', clearable: true,
            options: [
               { val: "current_table", label: "Current Table", forms: exports.form_fields_number.forms },
               { val: "other_table", label: "Other Table", forms: exports.other_form_fields_number.forms },
            ], validation: 'required', label: 'Number Field'
         },
         {
            type: 'select', class: 'col-12', model: 'country',
            options: [
               { val: 'Kenya', label: 'Kenya'},
               { val: 'Uganda', label: 'Uganda'},
               { val: 'Rwanda', label: 'Rwanda'},
               { val: 'Zambia', label: 'Zambia'},
            ], validation: 'required', label: 'Country'
         },
      ]
   },
   nextPage: {
      icon: 'fa fa-pencil-ruler',
      title: 'Customize Form',
      subtitle: 'Provide specific form details',
      forms: []
   },
   nextPageVisualization: {
      icon: 'fa fa-pencil-ruler',
      title: 'Customize Visualization',
      subtitle: 'Provide specific form visualization',
      forms: []
   },
}

let tables = {
   visuals: {
      props: {
         icon: 'fa fa-database',
         title: 'Visuals',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['type', 'name', 'index', 'table', 'date_field', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { 
               title: "Type", 
               width: 200, 
               key: "type", 
               filters: [{
                     label: "Stat Card",
                     value: 'stat_card'
                  },
                  {
                     label: "Doughnut",
                     value: 'doughnut'
                  },
                  {
                     label: "Pie",
                     value: 'pie'
                  },
                  {
                     label: "Calendar Chart",
                     value: 'calendar'
                  },
                  {
                     label: "Calendar Week",
                     value: 'calendar_week'
                  },
                  {
                     label: "Line",
                     value: 'line'
                  },
                  {
                     label: "Area",
                     value: 'area'
                  },
                  {
                     label: "Bar",
                     value: 'bar'
                  },
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  return row.type === value
               }
            },
            { title: "Name", min_width: 300, key: "name", },
            { title: "Index", width: 100, key: "index", align: 'center', sortable: true, },
            { title: "Table", key: "table", min_width: 200 },

            {
               title: "Status",
               key: "status",
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [{
                     label: "Created",
                     value: 1
                  },
                  {
                     label: "Updated",
                     value: 2
                  },
                  {
                     label: "Pending Create Verification",
                     value: 3
                  },
                  {
                     label: "Pending Update Verification",
                     value: 4
                  },
                  {
                     label: "Pending Delete Verification",
                     value: 5
                  }
               ],
               filterMultiple: true,
               filterMethod(value, row) {
                  switch (value) {
                     case 1:
                        return row.status === 'created';
                     case 2:
                        return row.status === 'updated';
                     case 3:
                        return row.status === 'create_pending';
                     case 4:
                        return row.status === 'update_pending';
                     case 5:
                        return row.status === 'delete_pending';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Edit', event: 'visuals:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'visuals:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: {...utils.generateAllFormData(forms),...utils.generateAllFormData(exports)},
   tables
}